import {
  Alert,
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@efexteam/components';
import { RoleId, RoleIds } from '@efexteam/permission-manager';
import { Box, Typography } from '@mui/material';
import { IMembers } from '@pages/profile/types';
import { useTranslation } from 'react-i18next';
import DeleteModalStyles from './DeleteModal.style';
import useDelete from './hooks/useDelete';

interface DeleteModalProps {
  memberData: IMembers;
  open: boolean;
  role: RoleId;
  onClose: () => void;
}

const DeleteModal = ({ memberData, open, role, onClose }: DeleteModalProps) => {
  const { t } = useTranslation();
  const { firstName, lastName } = memberData.naturalPerson;
  const fullName = `${firstName} ${lastName}`.trim();

  const { loading, error, deleteTeamMemberData } = useDelete({
    naturalPersonId: memberData.naturalPerson.id,
  });

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle
        className={DeleteModalStyles.dialogTitle}
        showCloseButton
        onClick={onClose}
      >
        <span> {t('roleDeleteModalTitle', { name: fullName })}</span>
      </DialogTitle>
      <DialogContent>
        <Box className={DeleteModalStyles.dialogContent}>
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar username={fullName} size="md" />
            <Typography>{fullName}</Typography>
          </Box>
          <Typography variant="body2" className={DeleteModalStyles.roleText}>
            {t(`member${RoleIds[role]}`)}
          </Typography>
        </Box>

        {error && (
          <Alert variant="outlined" severity="error">
            {error.message || t('roleDeleteModalError')}
          </Alert>
        )}
      </DialogContent>
      <DialogActions className={DeleteModalStyles.dialogActions}>
        <Button
          size="large"
          appearance="secondary"
          disabled={loading}
          onClick={onClose}
        >
          {t('cancel')}
        </Button>
        <Button
          size="large"
          appearance="primary"
          color="error"
          disabled={loading}
          onClick={() => deleteTeamMemberData()}
        >
          {t('roleDeleteModalAction')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
